<template>
  <div class="scroll-hor-cont">
    <table class="form-calculadora">
      <tr class="form-titles" >
        <th colspan="2"><p class="font-red davi-curs ">{{nombresCols}}</p></th>
        <th class="font-red davi-curs" ><p class="font-red davi-curs ">Valor</p></th>
      </tr>
      <template v-for="item in formulario">
        <tr class="tr-space"></tr>
        <tr v-for="(itemInt, indexInt) in item.valores" :class="indexInt===0?'tr-header':''">
          <td v-if="indexInt === 0" :rowspan="item.valores.length"><strong><div class="title-row font-red">{{item.nombre}}</div></strong></td>
          <td class="text-xs-right"><p>{{itemInt.desc}}</p></td>
          <td class="input-td">
            <p><input type="number" :aria-label="item.nombre" name="Valor" placeholder="Ingrese valor" v-model="itemInt.valor"></p>
          </td>
        </tr>
      </template>

      <template v-if="nombresCols === 'Activos'">
        <tr>
          <td colspan="2" class="text-xs-right font-red davi-curs">Total activo</td>
          <td class="input-td"><strong>${{patrimonioTotalActivos}}</strong></td>
        </tr>
      </template>

      <template v-if="nombresCols === 'Pasivos'">
        <tr>
          <td colspan="2" class="text-xs-right font-red davi-curs">Total activo</td>
          <td class="input-td"><strong>${{patrimonioTotalActivos}}</strong></td>
        </tr>
        <tr>
          <td colspan="2" class="text-xs-right font-red davi-curs">Menos (-) Total pasivo</td>
          <td class="input-td"><strong>${{patrimonioTotalPasivos}}</strong></td>
        </tr>
        <tr>
          <td colspan="2" class="text-xs-right"><p class="davi-curs">Patrimonio</p></td>
          <td class="input-td"><strong>${{diferenciaPatrimonio}}</strong></td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    formulario: {
      type: Array,
      required: true
    },
    nombresCols: {
      type: String,
      required: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    diferenciaPatrimonio(){
      return this.$store.getters.diferenciaPatrimonio
    },
    patrimonioTotalActivos() {
      return this.$store.getters.patrimonioTotalActivos;
    },
    patrimonioTotalPasivos() {
      return this.$store.getters.patrimonioTotalPasivos;
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/variables";
.form-calculadora {
  width: 100%;
  max-width: 1150px;
  min-width: 900px;
  margin: auto;
  border-collapse: collapse;
  padding: 10px;
  .form-titles {
    border-bottom: solid 2px $primary-red;
    p{
    font-size: 1.5rem !important;
    }
  }
  .form-end {
    border-top: solid 2px #bbb;
  }
  .input-td {
    text-align: center;
  }
  tr {
    th,
    td {
      position: relative;
      width: 25%;
      padding: 5px 10px;
      font-size: 1.2rem;
      line-height: 1.4rem;
      input {
        border: solid 1px $primary-red;
        text-align: center;
      }
      p{
        padding-top: 10px;
      }
    }
  }
}
.tr-header{
  border-top: solid 2px #777;
  line-height:30px;
}
.tr-space{
  height: 50px;
}

.title-row{
  font-size: 1.5rem;
  position: absolute;
  top: -25px;
}
</style>



// WEBPACK FOOTER //
// FormCalculadoraPatrimonio.vue?d4d19934